import { __decorate } from 'tslib';
import { ReactWrapperComponent, passProp, AngularReact, registerElement } from '@angular-react/core';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, ViewChild, Input, EventEmitter, ContentChildren, Output, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { Pivot, PivotItem } from '@fluentui/react/lib/Pivot';
import { Styled } from '@angular-react/fabric/lib/utils';
import { CommonModule } from '@angular/common';

let FabPivotItemComponent = class FabPivotItemComponent extends ReactWrapperComponent {
    constructor(elementRef, changeDetectorRef, renderer, ngZone) {
        super(elementRef, changeDetectorRef, renderer, { ngZone, setHostDisplay: true });
        this.disabled = false;
        this.visible = true;
    }
    ngOnInit() {
        this.onRenderItemLink = this.createRenderPropHandler(this.renderItemLink);
    }
};
/** @nocollapse */ FabPivotItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabPivotItemComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ FabPivotItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.1", type: FabPivotItemComponent, selector: "fab-pivot-item", inputs: { disabled: "disabled", visible: "visible", componentRef: "componentRef", headerText: "headerText", headerButtonProps: "headerButtonProps", itemKey: "itemKey", ariaLabel: "ariaLabel", itemCount: "itemCount", itemIcon: "itemIcon", keytipProps: "keytipProps", alwaysRender: "alwaysRender", renderItemLink: "renderItemLink" }, viewQueries: [{ propertyName: "reactNodeRef", first: true, predicate: ["reactNode"], descendants: true, static: true }], exportAs: ["fabPivotItem"], usesInheritance: true, ngImport: i0, template: `
    <PivotItem
      #reactNode
      [componentRef]="componentRef"
      [headerText]="headerText"
      [headerButtonProps]="headerButtonProps"
      [itemKey]="itemKey"
      [ariaLabel]="ariaLabel"
      [itemCount]="itemCount"
      [itemIcon]="itemIcon"
      [keytipProps]="keytipProps"
      [alwaysRender]="alwaysRender"
      [RenderItemLink]="renderItemLink && onRenderItemLink"
    >
      <ReactContent><ng-content></ng-content></ReactContent>
    </PivotItem>
  `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    passProp()
], FabPivotItemComponent.prototype, "componentRef", void 0);
__decorate([
    passProp()
], FabPivotItemComponent.prototype, "headerText", void 0);
__decorate([
    passProp()
], FabPivotItemComponent.prototype, "headerButtonProps", void 0);
__decorate([
    passProp()
], FabPivotItemComponent.prototype, "itemKey", void 0);
__decorate([
    passProp()
], FabPivotItemComponent.prototype, "ariaLabel", void 0);
__decorate([
    passProp()
], FabPivotItemComponent.prototype, "itemCount", void 0);
__decorate([
    passProp()
], FabPivotItemComponent.prototype, "itemIcon", void 0);
__decorate([
    passProp()
], FabPivotItemComponent.prototype, "keytipProps", void 0);
__decorate([
    passProp()
], FabPivotItemComponent.prototype, "alwaysRender", void 0);
__decorate([
    passProp()
], FabPivotItemComponent.prototype, "renderItemLink", void 0);
__decorate([
    passProp()
], FabPivotItemComponent.prototype, "onRenderItemLink", void 0);
FabPivotItemComponent = __decorate([
    AngularReact(),
    Styled('FabPivotItemComponent')
], FabPivotItemComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabPivotItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fab-pivot-item',
                    exportAs: 'fabPivotItem',
                    template: `
    <PivotItem
      #reactNode
      [componentRef]="componentRef"
      [headerText]="headerText"
      [headerButtonProps]="headerButtonProps"
      [itemKey]="itemKey"
      [ariaLabel]="ariaLabel"
      [itemCount]="itemCount"
      [itemIcon]="itemIcon"
      [keytipProps]="keytipProps"
      [alwaysRender]="alwaysRender"
      [RenderItemLink]="renderItemLink && onRenderItemLink"
    >
      <ReactContent><ng-content></ng-content></ReactContent>
    </PivotItem>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.NgZone }]; }, propDecorators: { reactNodeRef: [{
                type: ViewChild,
                args: ['reactNode', { static: true }]
            }], disabled: [{
                type: Input
            }], visible: [{
                type: Input
            }], componentRef: [{
                type: Input
            }], headerText: [{
                type: Input
            }], headerButtonProps: [{
                type: Input
            }], itemKey: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], itemCount: [{
                type: Input
            }], itemIcon: [{
                type: Input
            }], keytipProps: [{
                type: Input
            }], alwaysRender: [{
                type: Input
            }], renderItemLink: [{
                type: Input
            }], onRenderItemLink: [] } });
let FabPivotComponent = class FabPivotComponent extends ReactWrapperComponent {
    constructor(elementRef, changeDetectorRef, renderer) {
        super(elementRef, changeDetectorRef, renderer, { setHostDisplay: true });
        this.PivotType = Pivot;
        this.PivotItemType = PivotItem;
        this.onLinkClick = new EventEmitter();
        this.onLinkClickHandler = this.onLinkClickHandler.bind(this);
    }
    onLinkClickHandler(item, ev) {
        this.onLinkClick.emit({
            ev: ev && ev.nativeEvent,
            item: item,
        });
    }
};
/** @nocollapse */ FabPivotComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabPivotComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ FabPivotComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.1", type: FabPivotComponent, selector: "fab-pivot", inputs: { componentRef: "componentRef", styles: "styles", theme: "theme", className: "className", defaultSelectedKey: "defaultSelectedKey", selectedKey: "selectedKey", linkSize: "linkSize", linkFormat: "linkFormat", overflowBehavior: "overflowBehavior", headersOnly: "headersOnly", getTabId: "getTabId", children: "children" }, outputs: { onLinkClick: "onLinkClick" }, queries: [{ propertyName: "pivotItems", predicate: FabPivotItemComponent }], viewQueries: [{ propertyName: "reactNodeRef", first: true, predicate: ["reactNode"], descendants: true, static: true }], exportAs: ["fabPivot"], usesInheritance: true, ngImport: i0, template: `
    <Disguise
      #reactNode
      [disguiseRootAs]="PivotType"
      [disguiseChildrenAs]="PivotItemType"
      [ngChildComponents]="children || pivotItems?.toArray()"
      [componentRef]="componentRef"
      [styles]="styles"
      [theme]="theme"
      [className]="className"
      [defaultSelectedKey]="defaultSelectedKey"
      [selectedKey]="selectedKey"
      [linkSize]="linkSize"
      [linkFormat]="linkFormat"
      [overflowBehavior]="overflowBehavior"
      [headersOnly]="headersOnly"
      [getTabId]="getTabId"
      [LinkClick]="onLinkClickHandler"
    >
      <ReactContent><ng-content select="fab-pivot-item"></ng-content></ReactContent>
    </Disguise>
  `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
FabPivotComponent = __decorate([
    AngularReact(),
    Styled('FabPivotComponent')
], FabPivotComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabPivotComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fab-pivot',
                    exportAs: 'fabPivot',
                    template: `
    <Disguise
      #reactNode
      [disguiseRootAs]="PivotType"
      [disguiseChildrenAs]="PivotItemType"
      [ngChildComponents]="children || pivotItems?.toArray()"
      [componentRef]="componentRef"
      [styles]="styles"
      [theme]="theme"
      [className]="className"
      [defaultSelectedKey]="defaultSelectedKey"
      [selectedKey]="selectedKey"
      [linkSize]="linkSize"
      [linkFormat]="linkFormat"
      [overflowBehavior]="overflowBehavior"
      [headersOnly]="headersOnly"
      [getTabId]="getTabId"
      [LinkClick]="onLinkClickHandler"
    >
      <ReactContent><ng-content select="fab-pivot-item"></ng-content></ReactContent>
    </Disguise>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }]; }, propDecorators: { reactNodeRef: [{
                type: ViewChild,
                args: ['reactNode', { static: true }]
            }], pivotItems: [{
                type: ContentChildren,
                args: [FabPivotItemComponent]
            }], componentRef: [{
                type: Input
            }], styles: [{
                type: Input
            }], theme: [{
                type: Input
            }], className: [{
                type: Input
            }], defaultSelectedKey: [{
                type: Input
            }], selectedKey: [{
                type: Input
            }], linkSize: [{
                type: Input
            }], linkFormat: [{
                type: Input
            }], overflowBehavior: [{
                type: Input
            }], headersOnly: [{
                type: Input
            }], getTabId: [{
                type: Input
            }], children: [{
                type: Input
            }], onLinkClick: [{
                type: Output
            }] } });

// Copyright (c) Microsoft Corporation. All rights reserved.
const components = [FabPivotComponent, FabPivotItemComponent];
class FabPivotModule {
    constructor() {
        // Add any React elements to the registry (used by the renderer).
        registerElement('Pivot', () => Pivot);
        registerElement('PivotItem', () => PivotItem);
    }
}
/** @nocollapse */ FabPivotModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabPivotModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ FabPivotModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabPivotModule, declarations: [FabPivotComponent, FabPivotItemComponent], imports: [CommonModule], exports: [FabPivotComponent, FabPivotItemComponent] });
/** @nocollapse */ FabPivotModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabPivotModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabPivotModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: components,
                    exports: components,
                    schemas: [NO_ERRORS_SCHEMA],
                }]
        }], ctorParameters: function () { return []; } });

// Copyright (c) Microsoft Corporation. All rights reserved.

/**
 * Generated bundle index. Do not edit.
 */

export { FabPivotComponent, FabPivotItemComponent, FabPivotModule };
